import ObjectScreen from '@components/v2/layout/ObjectScreen/ObjectScreen';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useOrderCalculateContext } from '../../../../../contexts/OrderCalculate.context';
import { useOrderConditionContext } from '../../../../../contexts/OrderCondition.context';
import { useOrderEditSectionsContext } from '../../../../../edit/sections/OrderEditSections.context';
import { OrderEditSectionsEnum } from '../../../../../edit/sections/OrderEditSections.types';
import OrderTotalsSummary from '../../OrderTotalsSummary/OrderTotalsSummary';

interface OrderObjectSummarySectionProps {
  isReadOnlyView: boolean;
}

const OrderObjectSummarySection = ({ isReadOnlyView }: OrderObjectSummarySectionProps) => {
  const { summaryTotals, getConditionTotals } = useOrderCalculateContext();
  const { selectedConditionId, isAllConditionsSelected } = useOrderConditionContext();
  const { currentSection } = useOrderEditSectionsContext();

  const isFilteredByCondition =
    !isReadOnlyView &&
    currentSection === OrderEditSectionsEnum.PRODUCTS &&
    !isAllConditionsSelected;

  const totals = isFilteredByCondition
    ? getConditionTotals(selectedConditionId)
    : summaryTotals?.calculate?.total;

  if (!totals) {
    return null;
  }

  return (
    <ObjectScreen.Section
      title={LangEnum.ORDER_SUMMARY_TITLE}
      persistKey="order:summary"
      isDefaultOpen
    >
      <OrderTotalsSummary totals={totals} />
    </ObjectScreen.Section>
  );
};

export default OrderObjectSummarySection;
